<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h1>VIEW BOT STATISTICS</h1>
      <hr class="h1"/>
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd000628c8c56a179442e98da/emb" :is="'script'"></component>
      </div>
      <div class="container">
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'PartnerStatistics',
  components: {
    SideBar
  }
}
</script>